import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['amount', 'userAttends']
  static values = {
    coursePrice: Number,
    pricePerBooking: Boolean,
    userTooOld: Boolean
  }
  numFamilyMembers = 0

  connect() {
    this.clearAmount()
  }

  clearAmount() {
    this.amountTarget.innerHTML = '€ 0,00'
  }

  formatAmount(amount) {
    return `€ ${amount.toFixed(2).toString().replace('.', ',')}`
  }

  handleCheckboxUpdate(event) {
    // Validate if the user is too old for this course
    if (this.userTooOldValue) {
      event.preventDefault()
      this.userAttendsTarget.checked = false
      alert('Erwachsene können nicht zu Kinderkursen angemeldet werden!')
      return
    }
    // A seat is only taken once the club confirms the request, so the number of
    // people entered here is deliberately not capped by the free places.
    this.updateAmount()
  }

  handleFamilyMembersUpdate(event) {
    this.numFamilyMembers = parseInt(event.detail.numAssociations)
    this.updateAmount()
  }

  updateAmount() {
    if (this.numFamilyMembers > 0 || this.userAttendsTarget.checked) {
      let amount = 0
      let amountHTML = ''
      if (this.pricePerBookingValue) {
        amount = this.coursePriceValue
      } else {
        amount = this.numFamilyMembers * this.coursePriceValue
        if (this.userAttendsTarget.checked) {
          amount += this.coursePriceValue
        }
      }
      amountHTML = this.formatAmount(amount)
      this.amountTarget.innerHTML = amountHTML
    } else {
      this.clearAmount()
    }
  }
}
